function firstLetterToUpperCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const getReadTime = (content) => {
  const time = Math.round(content.length / 200);
  return time > 1 ? time : 1;
};

const replaceSpecialChars = (str) => {
  const newStr = str.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  return newStr;
};

const html2text = (str) => {
  if (str) {
    const tag = document.createElement('div');
    tag.innerHTML = str;
    return tag.innerText;
  }
  return '';
};

const replacerML = (obj, field) => {
  const preparedObj = {};
  Object.keys(obj).forEach((item) => {
    if (item === field && obj[item]) {
      preparedObj[item] = replaceSpecialChars(obj[item]);
    } else if (item === 'ml') {
      preparedObj.ml = {};
      Object.keys(obj.ml).forEach(i => preparedObj.ml[i] = replacerML(obj.ml[i], field));
    } else preparedObj[item] = obj[item];
  });
  return preparedObj;
};

export default { firstLetterToUpperCase, getReadTime, replacerML, replaceSpecialChars, html2text };



// WEBPACK FOOTER //
// ./src/helpers/string.helper.js